import {
  DECISIVE_CONDITION_ADDED,
  DECISIVE_CONDITION_EDITED,
  DECISIVE_CONDITION_DELETED,
  DECISIVE_CONDITION_SET,
} from 'src/app/redux/redux-types';
import { reduxDecisiveConditionTypes } from 'src/types';

export const decisiveConditionDefaultState: reduxDecisiveConditionTypes.StateType = {
  decisiveConditionList: [],
};

export const decisiveConditionReducer = (
  state = decisiveConditionDefaultState,
  decisiveCondition: reduxDecisiveConditionTypes.DecisiveConditionType,
): reduxDecisiveConditionTypes.StateType => {
  switch (decisiveCondition.type) {
    case DECISIVE_CONDITION_SET:
      return {
        ...state,
        decisiveConditionList: decisiveCondition.payload,
      };
    case DECISIVE_CONDITION_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.decisiveConditionList.some((item) => item.id === decisiveCondition.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        decisiveConditionList: [decisiveCondition.payload, ...state.decisiveConditionList],
      };
    case DECISIVE_CONDITION_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.decisiveConditionList.findIndex((obj) => obj.id === decisiveCondition.payload.id);
      return {
        ...state,
        decisiveConditionList: [
          ...state.decisiveConditionList.slice(0, updateIndex),
          decisiveCondition.payload,
          ...state.decisiveConditionList.slice(updateIndex + 1),
        ],
      };
    case DECISIVE_CONDITION_DELETED:
      return {
        ...state,
        decisiveConditionList: state.decisiveConditionList.filter((o) => o.id !== decisiveCondition.payload),
      };
    default:
      return state;
  }
};
